package modysy.model

/** Interface that describes the inner field - the region where
  * the game objects can reside an move in, surrounded by borders.
  */
abstract class InnerField {

  /** Check whether the provided shape at provided pose lies fully
    * within the inner field. */
  def containsFully(pose: Transform, shape: Geometry): Boolean

  /** A sequence storing the objects representing the borders
    * of the inner field.
    */
  val borders: Seq[FixedShapeGameObject]
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/InnerField.scala